function ListOfLanguage() {
    return (
      <>
        <div className="font-bold text-lg mb-16">ListOfLanguage</div>
      </>
    );
  }
  
  export default ListOfLanguage;